import { proxy } from 'valtio';

const state = proxy<{
  chainId: string;
  open: boolean;
  session: Record<string, unknown> | null;
  args: Record<string, unknown> | null;
  authorization: Array<Record<string, unknown>>;
  selected: string;
  version: number;
  uri: string;
}>({
  chainId: 'eip155:61', // 'eip155:5',
  open: false,
  session: null,
  args: null,
  authorization: [],
  selected: '',
  version: 0,
  uri: '',
});

export default state;
